// dashboard
export const PORTFOLIO_SUMMARY_REQUEST = "PORTFOLIO_SUMMARY_REQUEST";
export const PORTFOLIO_SUMMARY_ERROR = "PORTFOLIO_SUMMARY_ERROR";
export const PORTFOLIO_SUMMARY_SUCCESS = "PORTFOLIO_SUMMARY_SUCCESS";
export const INVESTMENT_SUMMARY_REQUEST = "INVESTMENT_SUMMARY_REQUEST";
export const INVESTMENT_SUMMARY_ERROR = "INVESTMENT_SUMMARY_ERROR";
export const INVESTMENT_SUMMARY_SUCCESS = "INVESTMENT_SUMMARY_SUCCESS";
export const CASH_LEDGER_REQUEST = "CASH_LEDGER_REQUEST";
export const CASH_LEDGER_ERROR = "CASH_LEDGER_ERROR";
export const CASH_LEDGER_SUCCESS = "CASH_LEDGER_SUCCESS";
export const RESET_WITHDRAWAL_AMOUNT = "RESET_WITHDRAWAL_AMOUNT";
// INVESTMENT
export const WITHDRAW_MONEY = "WITHDRAW_MONEY";
export const WITHDRAW_MONEY_SUCCESS = "WITHDRAW_MONEY_SUCCESS";
export const WITHDRAW_MONEY_ERROR = "WITHDRAW_MONEY_ERROR";
export const ADD_MONEY = 'ADD_MONEY';
export const ADD_MONEY_SUCCESS = "ADD_MONEY_SUCCESS";
export const ADD_MONEY_ERROR = "ADD_MONEY_REQUEST";
export const SELECT_TENURE_VALUE = "SELECT_TENURE_VALUE";
export const ADD_AMOUNT_VALUE = "ADD_AMOUNT_VALUE";
//refer earn
export const REFER_EARN_REQUEST = "REFER_EARN_REQUEST";
export const REFER_EARN_ERROR = "REFER_EARN_ERROR";
export const REFER_EARN_SUCCESS = "REFER_EARN_SUCCESS";
// getUserConfirmation
export const GET_BANK_ACCOUNT_DETAILS ="GET_BANK_ACCOUNT_DETAILS";
export const GET_BANK_ACCOUNT_DETAILS_SUCCESS = "GET_BANK_ACCOUNT_DETAILS_SUCCESS";
export const GET_BANK_ACCOUNT_DETAILS_ERROR = "GET_BANK_ACCOUNT_DETAILS_ERROR";

// BORROWER
export const FETCH_BORROWER_DETAILS = "FETCH_BORROWER_DETAILS";
export const FETCH_BORROWER_DETAILS_SUCCESS = "FETCH_BORROWER_DETAILS_SUCCESS";
export const FETCH_BORROWER_DETAILS_ERROR = "FETCH_BORROWER_DETAILS_ERROR";